import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/influencer-program/_components/InfluencerProgramClient.tsx");
